import { useTranslation } from '@shared/core';
import { useDocumentTitle } from '@shared/utils/hooks/useDocumentTitle';

export const usePageTitleConfirmPayment = () => {
  const { t } = useTranslation('guestRegistry');
  const { confirmPaymentTitle } = t('pageTitle');
  useDocumentTitle(confirmPaymentTitle());
};
